<template>
    <v-container class="student-efforts">
        <v-alert v-model="noEfforts"  icon="warning" outline>
        No efforts for the selected period.
        </v-alert>
        <v-card v-if="hasEfforts" >
            <v-toolbar dense>
                <v-toolbar-title>
                    {{ efforts.groupName }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <grades-downloader :classId="0" isStudent="true"></grades-downloader>
            </v-toolbar>
            <grading-tabs 
                v-model="efforts" 
                v-on:grade-changed="onGradeChanged" 
                v-on:save-failed="saveFailed()" 
                hide-title="true" 
                isStudent="true"
                :settings="settings" 
                :readonly="readonly"
            ></grading-tabs>
            

        </v-card>
    </v-container>
</template>
<script>

import { getStudentEfforts, getReportingPeriodStatus, initialize, getPeriods, getGradingButtonsSettings } from '../utils/effort-tracking-api';
import GradingTabs from './GradingTabs';
import GradesDownloader from './GradesDownloader';
// import { store } from '../store';
// import { globalStore } from '../main';

export default {
    name: "student-efforts",
    data () { 
        return { 
            efforts: '', hasEfforts: false, 
            noEfforts: false, 
            settings: [],
            readonly: false,
            isTeacher: false
        }
    },
    components: {
       GradingTabs,
       GradesDownloader
    },
    methods: {
        update(loadEfforts) {
            var userid = this.$route.params.studentId;
            var paramsId = this.$route.params.studentId;
            var usertype = this.$store.state.usertype;
            if (userid != paramsId && usertype != 'admin' && usertype != 'middlemanager')
            {
                window.location.href = '#/users/login'
            }

            if(!loadEfforts)
                return

            getStudentEfforts(this.$route.params.studentId, this.$route.params.periodId).then((efforts) => {
                this.$emit('show-period-notification');
                if(efforts.effortGroups.length > 0 && efforts.effortGroups[0].effortGroups.length > 0) {
                    this.hasEfforts = true;
                    this.noEfforts = false;
                    this.efforts = efforts;
                    return true;
                }
                else {
                    this.hasEfforts = false;
                    this.noEfforts = true;
                    return false;
                }
            });
        },

        onGradeChanged: function(result, classId) {
            localStorage.removeItem('saving');
            this.update(true);
        },

        saveFailed() {
            localStorage.setItem('saving', true);
        }
    },
    mounted() {
        var periodId = localStorage.getItem('period-selected');
        var userid = this.$route.params.studentId;
        initialize().then(x => {            
            getGradingButtonsSettings().then(settings => {
                this.settings = settings;
                getPeriods().then( periods => {
                    var periodId = localStorage.getItem('period-selected');
                    if (periodId != 'undefined')
                    {
                        var p = periods.filter( p => Number(p.value) == periodId);
                        
                        if (p[0].visible || this.$store.state.usertype == 'admin')
                        {

                            this.isTeacher = (this.$store.state.usertype == 'teacher' || this.$store.state.usertype == 'middlemanager' ? true : false );
                            getReportingPeriodStatus().then(result => {  
                                this.readonly = !result.active || result.complete;
                            }).catch(ex => console.log(ex));
                            //this.readonly = !p[0].active || p[0].complete;

                            this.update(true);
                        }
                    }
                });
            }).catch(ex => console.log(ex));
        });
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.meta.requiresResourceProperty && vm.$store.state.usertype == 'student')
            {
                if (parseInt(vm.$store.state.userdata.id) !== parseInt(vm.$route.params.studentId))
                {
                    vm.$route.params.studentId = vm.$store.state.userdata.id;
                    window.location.href = '#/';
                }
            }
        });
    },

    updateEffort(){
        var userId = this.$route.params.studentId;
        var periodId = localStorage.getItem('period-selected');
    },

    beforeRouteLeave: (to, from , next) => {
        var saving = localStorage.getItem('saving');
        if(saving != null) {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                localStorage.removeItem('saving');
                next()
            } else {
                next(false)
            }
        } else {
            localStorage.removeItem('saving');
            next();
        }    
    },
}
</script> 


// WEBPACK FOOTER //
// src/components/StudentEfforts.vue